import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { BannerDetailsModule } from '@/modules/banner-management/banner-details';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/banner-management/new')({
  component: NewBannerPage,
});

function NewBannerPage() {
  const { canAccessBannerManagement } = useAccessControl();
  if (!canAccessBannerManagement) return <AccessDenied />;

  return <BannerDetailsModule />;
}
